import React from "react";
import locale from "@bonliva-crm/locale";
import { TableSearchColumn } from "@search/TableSearch";
import { Body } from "@components";
import { BookingAuditSearchStore } from "./BookingAuditSearchStore";
import { ItemType } from "./utils";
import { WeekStatus } from "./components/WeekStatus";
import NationellaListMark from "@common/NationellaListMark";
import RowActions from "@bookings/BookingSearch/RowActions";

export const getColumns = (
  store: BookingAuditSearchStore
): Array<TableSearchColumn<ItemType>> => [
  {
    label: "",
    dataKey: "attention",
    vAlign: "center",
    width: 48,
    style: { justifyContent: "center", color: "#535353" },
    cellRenderer: ({ rowData }) => null
  },
  {
    label: locale.Consultant,
    dataKey: "consultant",
    vAlign: "center",
    style: { paddingLeft: 10 },
    cellRenderer: ({ rowData }) => <Body>{rowData.data.ConsultantRef.Name}</Body>
  },
  {
    label: "Audit",
    dataKey: "audit",
    vAlign: "center",
    cellRenderer: ({ rowData }) => (
      <WeekStatus
        data={rowData.data.BookingAudit}
        onCheck={(checked) =>
          store.setBookingAudit(rowData.data.BookingRef.NodeID, checked)
        }
        onComment={(value) => store.updateComment(rowData.data.BookingRef.NodeID, value)}
      />
    )
  },
  {
    label: locale.Customer,
    dataKey: "customer",
    vAlign: "center",
    cellRenderer: ({ rowData }) => (
      <>
        <div>
          <Body block>{rowData.data.OrganizationRef.Name}</Body>
          <Body block>{rowData.data.HospitalRef.Name}</Body>
          {rowData.data.DepartmentsRefs.length > 0 && (
            <Body block>
              {rowData.data.DepartmentsRefs.map((x) => x.Name).join(", ")}
            </Body>
          )}
        </div>
        {rowData.data.isNationalProcurement && <NationellaListMark />}
      </>
    )
  },
  {
    label: locale.AreaOfExpertise,
    dataKey: "aoe",
    vAlign: "center",
    cellRenderer: ({ rowData }) => <Body>{rowData.data.AreaOfExpertise}</Body>
  },
  {
    width: 96,
    label: locale.Project,
    dataKey: "project",
    vAlign: "center",
    cellRenderer: ({ rowData }) => {
      if (!rowData.data?.ProjectId) {
        return null;
      }

      return (
        <Body title={`Projektnr: ${rowData.data?.projectNumber ?? "not found"}`}>
          {rowData.data?.projectName ?? "not found"}
        </Body>
      );
    }
  },
  {
    width: 50,
    fitted: true,
    label: null,
    dataKey: "actions",
    style: { justifyContent: "center" },
    cellRenderer: ({ rowData }) => {
      return (
        <RowActions
          id={rowData.data.BookingRef.NodeID}
          onCloneBooking={store.cloneBookingForMonthlyBrake}
        />
      );
    }
  }
];
